'use strict';

angular.module('web2print.newAddress')
  .factory('individualsFactory', function () {
    const factory = {};
    const householdTypes = [
      {
        'selected': true,
        'modelKey': 'all',
        'btnLabel': 'ALL',
        'info': 'ALL'

      }, {
        'selected': true,
        'modelKey': 'youth',
        'btnLabel': 'YOUTH',
        'info': 'NEW_ADDRESS_PAGE_YOUTH_INFO',
        'number': 1
      }, {
        'selected': true,
        'modelKey': 'single',
        'btnLabel': 'SINGLE',
        'info': 'NEW_ADDRESS_PAGE_SINGLE_INFO',
        'number': 2
      }, {
        'selected': true,
        'modelKey': 'couple',
        'btnLabel': 'NEW_ADDRESS_PAGE_COUPLE_CHILDREN',
        'info': 'NEW_ADDRESS_PAGE_COUPLE_CHILDREN_INFO',
        'number': 4

      }, {
        'selected': true,
        'modelKey': 'familyChildren',
        'btnLabel': 'NEW_ADDRESS_PAGE_FAMILY_YOUNG_CHILDREN',
        'info': 'NEW_ADDRESS_PAGE_FAMILY_YOUNG_CHILDREN_INFO',
        'number': 5
      }, {
        'selected': true,
        'modelKey': 'familyYouth',
        'btnLabel': 'NEW_ADDRESS_PAGE_FAMILY_YOUTH_HOME',
        'info': 'NEW_ADDRESS_PAGE_FAMILY_YOUTH_HOME_INFO',
        'number': 3
      }, {
        'selected': true,
        'modelKey': 'establishedFamily',
        'btnLabel': 'NEW_ADDRESS_PAGE_ESTABLISHED_FAMILY',
        'info': 'NEW_ADDRESS_PAGE_ESTABLISHED_FAMILY_INFO',
        'number': 6,
      }, {
        'selected': true,
        'modelKey': 'middle-aged',
        'btnLabel': 'MIDDLE-AGED',
        'info': 'NEW_ADDRESS_PAGE_MIDDLE-AGE_INFO',
        'number': 7,
      }, {
        'selected': true,
        'modelKey': 'senior',
        'btnLabel': 'SENIORS',
        'info': 'NEW_ADDRESS_PAGE_SENIOR_INFO',
        'number': 8,
      }];

    const lodging = [{
      'selected': true,
      'modelKey': 'all',
      'btnLabel': 'ALL'
    }, {
      'selected': true,
      'modelKey': 'smallHouses',
      'btnLabel': 'ADR_HOUSES',
      'number': 1
    }, {
      'selected': true,
      'modelKey': 'tenant',
      'btnLabel': 'TENANT',
      'number': 3
    }, {
      'selected': true,
      'modelKey': 'tenancy',
      'btnLabel': 'ADR_CONDO',
      'number': 2
    }, {
      'selected': true,
      'modelKey': 'mix',
      'btnLabel': 'OTHER',
      'number': 4
    }];

    function setSelected (arrKey, arrSelected) {
      // arrKey - key for the array to be modified
      // arrSelected - array that contains selcted options
      const arr = angular.copy(factory[arrKey]);
      if (arrSelected.length) {
        arr.forEach(function (item) {
          if (arrSelected.indexOf(item.number) < 0) {
            item.selected = false;
          }
        });
      }

      return arr;
    }

    function getSliderVal (slider, purchasingPower) {
      slider.min = purchasingPower[0];
      slider.max = purchasingPower[purchasingPower.length - 1];

      return slider;
    }

    function getFilters (selected, filterCategory) {
      switch (selected) {
        case null:
          // everything selected
          return angular.copy(factory[filterCategory]);
        case undefined:
          // nothing selected
          return setSelected(filterCategory, []);
        default:
          // some selected
          return setSelected(filterCategory, selected);
      }
    }


    factory.householdTypes = householdTypes;
    factory.lodging = lodging;
    factory.setSelected = setSelected;
    factory.getSliderVal = getSliderVal;
    factory.getFilters = getFilters;

    return factory;
  });
